import { ToastrService } from 'ngx-toastr';
import { SharedService } from '@services/shared.service';
import { addresses } from 'src/data/account-addresses';
import { TranslateHelper } from '@app/_helpers';
import { Component, OnInit, Inject, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogRef as MatDialogRef, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as _ from 'lodash';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ReplaySubject, Subject } from 'rxjs';
import { AuthenticationService, UserService } from '@app/_services';
import { compareTwoStrings } from "string-similarity";
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { NgFor, AsyncPipe } from '@angular/common';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';

@UntilDestroy()
@Component({
    selector: 'app-city-dialog',
    templateUrl: './city-dialog.component.html',
    styleUrls: ['./city-dialog.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [MatDialogContent, MatFormFieldModule, MatSelectModule, FormsModule, ReactiveFormsModule, MatOptionModule, NgxMatSelectSearchModule, NgFor, MatDialogActions, MatButtonModule, MatDialogClose, AsyncPipe, TranslateModule]
})
export class CityDialogComponent implements OnInit, AfterViewInit {

    constructor(private fb: UntypedFormBuilder, private router: Router, private route: ActivatedRoute, private dialogref: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) data,
        public translate: TranslateHelper, public authService: AuthenticationService, private sharedService: SharedService,
        private userService: UserService, private toastr: ToastrService) {
        if (data.action) {
            this.action = data.action;
        }

        if (data.country) {
            this.country = _.cloneDeep(data.country);
            this.originalCountry = _.cloneDeep(data.country);
            this.filteredAreas.next(this.country?.areas);
        }
    }
    ngAfterViewInit(): void {
        //if (this.user?.preferences?.zone) this.cityControl.setValue(this.user?.preferences?.zone);
    }

    public filterCtrl: UntypedFormControl = new UntypedFormControl();
    destroy$: Subject<void> = new Subject<void>();
    cityControl: UntypedFormControl = new UntypedFormControl();
    action;
    filteredAreas: ReplaySubject<any> = new ReplaySubject<any>(1);
    originalCountry;
    country;
    user;

    ngOnInit(): void {
        this.filterCtrl.valueChanges.pipe(
            debounceTime(50),
            distinctUntilChanged(),
            untilDestroyed(this)
        ).subscribe(value => this.onFilterChanged(value));
        this.authService.currentZone.subscribe((currentZone) => {
            if (!currentZone) return;


            let country = this.country;
            let zone: any = false;

            if (country._id == currentZone.country?._id)
                zone = currentZone;;
            this.cityControl.patchValue({
                cityId: null,
                areaId: "",
            });

            if (zone) {
                this.cityControl.patchValue({
                    cityId: zone.city?._id,
                    areaId: zone.area?._id,
                });
            } else {
                let value: any = {};
                if (country._id == currentZone.country?._id)
                    zone = currentZone ?? false;
                if (!_.isEmpty(zone)) {
                    value = {
                        cityId: zone.city?._id,
                        areaId: zone.area?._id,
                    };
                }
                if (!_.isEmpty(value)) {
                    this.cityControl.patchValue(value);
                }
            }
        });

    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    onFilterChanged(value: string) {
        if (!this.originalCountry) {
            return;
        }
        if (value?.length == 0) {
            this.filteredAreas.next(this.originalCountry.areas);
            return;
        }
        value = value.toLowerCase();
        const matchSimilarity = 0.5;
        _.each(this.country.areas, (area: any) => {
            let areaEnabled = false;
            _.each(area.cities, (city) => {
                let cityNameEn = city.name.en.toLowerCase();
                let cityNameAr = city.name.ar;
                let cityMatched = (compareTwoStrings(cityNameEn, value) > matchSimilarity) ||
                    (compareTwoStrings(cityNameAr, value) > matchSimilarity) ||
                    _.includes(cityNameEn, value) ||
                    _.includes(cityNameAr, value);
                if (cityMatched) areaEnabled = true;
                city.disabled = !cityMatched;
            });
            area.disabled = !areaEnabled;
        });
        this.filteredAreas.next(this.country.areas);
    }

    setLocation() {
        if (this.cityControl.invalid) return;
        let value = this.cityControl.value;
        if (!value) value = {};
        value.countryId = this.country._id;
        this.userService.setCity(value).subscribe((response) => {
            if (response.code == 200) {
                this.sharedService.selectedCitySubject$.next(value);
                this.router.routeReuseStrategy.shouldReuseRoute = () => false;
                this.router.onSameUrlNavigation = 'reload';
                this.authService.loadUserDetails();
                this.router.navigate([], { relativeTo: this.route, queryParamsHandling: 'preserve' });
                this.dialogref.close(response.data);
            } else {
                this.toastr.error("Error setting city.");
                this.dialogref.close();
            }
        }, error => {
            this.toastr.error("Error setting city.");
            this.dialogref.close();
        });
    }

    compareFn(x: any, y: any): boolean {
        return x?.cityId == y?.cityId && x?.areaId == y?.areaId;
    }
}
